import React from 'react';

import { Text } from '@atlaskit/primitives/compiled/text';

export type SessionTitleProps = {
	children: string;
	/** Truncate to one line instead of wrapping. Defaults to false. */
	truncate?: boolean;
	testId?: string;
};

/** Presents a session title; the consumer owns its placement and fallback text. */
export const SessionTitle = ({
	children,
	truncate = false,
	testId,
}: SessionTitleProps): React.JSX.Element => (
	<Text as="span" weight="medium" maxLines={truncate ? 1 : undefined} testId={testId}>
		{children}
	</Text>
);
